export const RepairOrderDeafult = { datesAvailable: [], maintenances: [] };
